export enum AccountStatus {
  Active = 'ACTIVO',
  Inactive = 'INACTIVO',
}
